// ============================================================================
// Minimal DOM helpers — a tiny vanilla-JS view layer (no framework, spec §15.1).
// ============================================================================

/**
 * Create an element. `tag` may include `.class` and `#id` shorthands
 * (e.g. 'button.btn.primary'). `props` sets attributes/props and `on*` events.
 */
export function el(tag, props = {}, children = []) {
  const [name, ...rest] = tag.split(/(?=[.#])/);
  const node = document.createElement(name || 'div');
  for (const token of rest) {
    if (token[0] === '.') node.classList.add(token.slice(1));
    else if (token[0] === '#') node.id = token.slice(1);
  }
  for (const [k, v] of Object.entries(props)) {
    if (v == null || v === false) continue;
    if (k === 'class') node.className = v;
    else if (k === 'html') node.innerHTML = v;
    else if (k === 'text') node.textContent = v;
    else if (k === 'dataset') Object.assign(node.dataset, v);
    else if (k.startsWith('on') && typeof v === 'function') {
      node.addEventListener(k.slice(2).toLowerCase(), v);
    } else if (k in node && k !== 'list') {
      try { node[k] = v; } catch { node.setAttribute(k, v); }
    } else {
      node.setAttribute(k, v);
    }
  }
  for (const child of [].concat(children)) {
    if (child == null || child === false) continue;
    node.append(child.nodeType ? child : document.createTextNode(String(child)));
  }
  return node;
}

/** Replace the contents of `mount` with `nodes`. */
export function mount(mountEl, ...nodes) {
  mountEl.replaceChildren(...nodes.filter(Boolean));
  return mountEl;
}

/** Simple toast/status line for transient messages. */
export function toast(message, kind = 'info') {
  let host = document.querySelector('.toast-host');
  if (!host) {
    host = el('div.toast-host');
    document.body.append(host);
  }
  const t = el(`div.toast.toast--${kind}`, { text: message });
  host.append(t);
  setTimeout(() => t.classList.add('toast--in'), 10);
  setTimeout(() => {
    t.classList.remove('toast--in');
    setTimeout(() => t.remove(), 300);
  }, 3200);
}
